import React, { useEffect, useState } from "react"
import { getFieldData, getFormatedNumber } from "../../Services/appService"
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../store/auth";
import { getFilterAllCandidates, loadCandidatesByFilter } from "../store/candidate";
import RateEncryptDecrypt from "../../Services/RateEncryptDecrypt";

const CANDIDATE_INFO_STYLES = {
    shell: {
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        borderRadius: "18px",
        boxShadow: "0 10px 26px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    hero: {
        padding: "10px 18px 10px 18px",
        background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%)",
        borderBottom: "1px solid rgba(203, 213, 225, 0.8)",
        display: "flex",
        alignItems: "center"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        gap: "18px",
        flexWrap: "wrap",
        alignItems: "center",
        width: "100%"
    },
    heroCopy: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        minWidth: "220px",
        flex: 1,
        justifyContent: "center"
    },
    title: {
        fontSize: "22px",
        fontWeight: 700,
        lineHeight: 1.1,
        color: "#0f172a",
        margin: 0,
        textTransform: "uppercase"
    },
    subtitle: {
        fontSize: "13px",
        color: "#475569",
        margin: 0,
        maxWidth: "720px"
    },
    badgeRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "nowrap",
        alignItems: "stretch",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: "2px",
        scrollbarWidth: "thin"
    },
    badge: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "6px 14px",
        borderRadius: "999px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(191, 219, 254, 1)",
        color: "#1d4ed8",
        fontSize: "11px",
        fontWeight: 700,
        boxShadow: "0 6px 18px rgba(37, 99, 235, 0.08)",
        // minHeight: "46px",
        flex: "0 0 auto",
        whiteSpace: "nowrap"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "12px",
        padding: "14px 18px 18px 18px"
    },
    card: {
        backgroundColor: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 1)",
        borderRadius: "16px",
        padding: "12px 14px",
        minHeight: "100%",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)"
    },
    cardLabel: {
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "8px"
    },
    primaryText: {
        fontSize: "15px",
        fontWeight: 700,
        lineHeight: 1.25,
        color: "#0f172a",
        marginBottom: "4px",
        wordBreak: "break-word"
    },
    secondaryText: {
        fontSize: "13px",
        lineHeight: 1.45,
        color: "#475569",
        marginBottom: "2px",
        wordBreak: "break-word"
    },
    durationSummary: {
        display: "flex",
        alignItems: "center",
        // justifyContent: "space-between",
        gap: "8px",
        // padding: "5px 10px",
        // borderRadius: "12px",
        // background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        color: "#1e3a8a",
        fontSize: "12px",
        fontWeight: 700,
        marginBottom: "2px",
        // boxShadow: "inset 0 0 0 1px rgba(147, 197, 253, 0.6)",
        width: "100%"
    },
    durationSummaryValue: {
        fontSize: "13px",
        fontWeight: 800,
        color: "#0f172a",
        width: "100%",
        textAlign: "right"
    },
    durationTimeline: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        paddingLeft: "16px"
    },
    durationLine: {
        position: "absolute",
        left: "5px",
        top: "4px",
        bottom: "4px",
        width: "2px",
        background: "linear-gradient(180deg, #93c5fd 0%, #dbeafe 100%)"
    },
    durationRow: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px"
    },
    durationDot: {
        position: "absolute",
        left: "-16px",
        top: "5px",
        width: "10px",
        height: "10px",
        borderRadius: "999px",
        backgroundColor: "#2563eb",
        boxShadow: "0 0 0 3px rgba(219, 234, 254, 1)"
    },
    durationLabel: {
        fontSize: "10px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#64748b",
        minWidth: "42px"
    },
    durationDate: {
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: 1.3,
        color: "#0f172a",
        textAlign: "right"
    },
    emptyText: {
        fontSize: "13px",
        color: "#94a3b8",
        margin: 0
    }
};

export default function CandidateInfo() {

    const [candidate, setCandidate] = useState(null);
    const [entityType, setEntityType] = useState("");

    const candidateSelector = useSelector(getFilterAllCandidates);
    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        getCandidateDetails(currentUser.id);
    }, []);

    const getCandidateDetails = (id) => {
        const frmBody = new FormData();
        frmBody.append("id", id);
        frmBody.append("name", "");
        frmBody.append("email", "");
        frmBody.append("entity", "");
        frmBody.append("type", "candidate");
        frmBody.append("filterType", "single");
        dispatch(loadCandidatesByFilter(frmBody));
    };

    useEffect(() => {
        if (candidateSelector.length > 0) {
            setCandidate(candidateSelector[0]);
            const entType = getFieldData(candidateSelector[0].performerData, "candidateonboardingform", "CandidateEntity");
            setEntityType(entType);
        }

    }, [candidateSelector]);

    let item = "";
    if (candidate) item = candidate;

    const positionTitle = candidate ? getFieldData(candidate.performerData, "projectengagement", "PositionTitle") : "";
    const agencyName = candidate ? getFieldData(candidate.performerData, "projectengagement", "AgencyName") : "";
    const mspMode = candidate ? getFieldData(candidate.performerData, "candidateonboardingform", "Msp_Mode") : "";
    const w9Type = candidate ? getFieldData(candidate.performerData, "candidateonboardingform", "w9_Type") : "";
    const showRate = entityType === "1099 Basis" || entityType === "W2 Basis";

    const renderRateDetails = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Compensation details are loading.</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.primaryText}>{entityType ? entityType.replace("Basis", "").trim() : "Entity type not available"}</div>
            {positionTitle && <div style={CANDIDATE_INFO_STYLES.secondaryText}>{positionTitle}</div>}
            {entityType === "W2 Basis" && w9Type && <div style={CANDIDATE_INFO_STYLES.secondaryText}>{w9Type}</div>}
        </>;
    };

    const renderSubcontractor = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Subcontractor information is loading.</p>;
        }

        if (entityType !== "C2C Basis") {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Not applicable for this entity type.</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.primaryText}>{item.subcontractor?.label || "No subcontractor on file."}</div>
            <div style={CANDIDATE_INFO_STYLES.secondaryText}>ID: {item.validId || "--"}</div>
            <div style={CANDIDATE_INFO_STYLES.secondaryText}>{item.subcontractor?.email || "No email on file."}</div>
        </>;
    };

    const renderAgency = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Agency information is loading.</p>;
        }

        if (!agencyName) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Not applicable.</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.primaryText}>{agencyName}</div>
            <div style={CANDIDATE_INFO_STYLES.secondaryText}>{mspMode || "MSP mode not provided."}</div>
        </>;
    };

    const renderDuration = () => {
        if (!candidate) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>Duration details are loading.</p>;
        }

        if (!item.duration) {
            return <p style={CANDIDATE_INFO_STYLES.emptyText}>No project duration on file.</p>;
        }

        return <>
            <div style={CANDIDATE_INFO_STYLES.durationSummary}>
                <i className="fa fa-hourglass-half" aria-hidden="true"></i>
                <span>Term</span>
                <span style={CANDIDATE_INFO_STYLES.durationSummaryValue}>{item.duration.duration} Month</span>
            </div>
            <div style={CANDIDATE_INFO_STYLES.durationTimeline}>
                <span style={CANDIDATE_INFO_STYLES.durationLine} aria-hidden="true"></span>
                <div style={CANDIDATE_INFO_STYLES.durationRow}>
                    <span style={CANDIDATE_INFO_STYLES.durationDot} aria-hidden="true"></span>
                    <span style={CANDIDATE_INFO_STYLES.durationLabel}>Start</span>
                    <span style={CANDIDATE_INFO_STYLES.durationDate}>
                        <Moment format="MMM Do YYYY">{item.duration.startDate}</Moment>
                    </span>
                </div>
                <div style={CANDIDATE_INFO_STYLES.durationRow}>
                    <span style={CANDIDATE_INFO_STYLES.durationDot} aria-hidden="true"></span>
                    <span style={CANDIDATE_INFO_STYLES.durationLabel}>End</span>
                    <span style={CANDIDATE_INFO_STYLES.durationDate}>
                        {item.duration.endDate ? <Moment format="MMM Do YYYY">{item.duration.endDate}</Moment> : "--"}
                    </span>
                </div>
            </div>
        </>;
    };

    return <React.Fragment>
        <div style={CANDIDATE_INFO_STYLES.shell}>
            <div style={CANDIDATE_INFO_STYLES.hero}>
                <div style={CANDIDATE_INFO_STYLES.heroRow}>
                    <div style={CANDIDATE_INFO_STYLES.heroCopy}>
                        <h2 style={CANDIDATE_INFO_STYLES.title}>
                            {candidate ? `${item.performername || ""} ${item.lastName || ""}`.trim() : "Candidate Information"}
                        </h2>
                    </div>
                    <div style={CANDIDATE_INFO_STYLES.badgeRow}>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-id-badge" aria-hidden="true"></i>
                            Candidate #: {candidate ? item.performerid : "--"}
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-credit-card" aria-hidden="true"></i>
                            IPCS ID: {candidate ? item.maxloans : "--"}
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-money" aria-hidden="true"></i>
                            Rate: {candidate && showRate ? (item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr") : "--"}
                        </span>
                        <span style={CANDIDATE_INFO_STYLES.badge}>
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                            Registered: {candidate ? <><Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>{" | "}<Moment format="h:mm a">{item.addedDateTime}</Moment></> : "--"}
                        </span>
                    </div>
                </div>
            </div>

            <div style={CANDIDATE_INFO_STYLES.grid}>
                <div style={CANDIDATE_INFO_STYLES.card}>
                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Candidate Details</div>
                    {candidate ? <>

                        <div style={CANDIDATE_INFO_STYLES.secondaryText}>{item.performeremail || "No email on file."}</div>
                        <div style={CANDIDATE_INFO_STYLES.secondaryText}>
                            {item.contactNo ? getFormatedNumber(item.contactNo) : "No phone on file."}
                        </div>
                    </> : <p style={CANDIDATE_INFO_STYLES.emptyText}>Candidate details are loading.</p>}
                </div>

                <div style={CANDIDATE_INFO_STYLES.card}>
                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Entity</div>
                    {renderRateDetails()}
                </div>

                <div style={CANDIDATE_INFO_STYLES.card}>
                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Subcontractor</div>
                    {renderSubcontractor()}
                </div>

                <div style={CANDIDATE_INFO_STYLES.card}>
                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Agency / MSP</div>
                    {renderAgency()}
                </div>

                <div style={CANDIDATE_INFO_STYLES.card}>
                    <div style={CANDIDATE_INFO_STYLES.cardLabel}>Duration</div>
                    {renderDuration()}
                </div>
            </div>
        </div>
    </React.Fragment>
}
